const googleCalendar = {
  upcoming: "אירועים קרובים",
  today: "היום",
  tomorrow: "מחר",
  allDay: "כל היום",
  noEvents: "אין אירועים קרובים",
  noAccount: "לא חובר חשבון Google Calendar",
  connectAccount: "חבר חשבון בהגדרות",
  openInCalendar: "פתח ב-Google Calendar",
  startsIn: "מתחיל בעוד",
} as const;
export default googleCalendar;
